import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import AuthWrapper from './Contexts/AuthWrapper';
import SnackbarProvider from './Contexts/SnackbarProvider';
import ThemeContext from './Contexts/ThemeContext';
import { TokenProvider } from './Contexts/TokenContext';
import './index.css';
import { registerGlobalTelemetryErrorHandlers } from './utils/telemetry';

import { LicenseInfo } from '@mui/x-license';
import { CssBaseline } from '@mui/material';

const muiLicenseKey = import.meta.env.VITE_MUI_PRO_LICENSE as string;
LicenseInfo.setLicenseKey(muiLicenseKey);
registerGlobalTelemetryErrorHandlers();
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppErrorBoundary>
    <ThemeContext>
      <CssBaseline />
      <BrowserRouter>
        <TokenProvider>
          <AuthWrapper>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </AuthWrapper>
        </TokenProvider>
      </BrowserRouter>
    </ThemeContext>
  </AppErrorBoundary>
);
